import React from 'react'
import { HelmetDatoCms } from 'gatsby-source-datocms'
import { graphql, StaticQuery } from 'gatsby'

const SEO = ({ seo }) => (
  <StaticQuery
    query={graphql`
      query SeoQuery {
        datoCmsSite {
          locale
          faviconMetaTags {
            ...GatsbyDatoCmsFaviconMetaTags
          }
        }
      }
    `}
    render={({ datoCmsSite }) => {
      return (
        <HelmetDatoCms favicon={datoCmsSite.faviconMetaTags} seo={seo}>
          <html lang="fr" />
        </HelmetDatoCms>
      )
    }}
  />
)

export default SEO
